import { render, staticRenderFns } from "./StepExtendedBanners.vue?vue&type=template&id=97f8679a&scoped=true&"
import script from "./StepExtendedBanners.vue?vue&type=script&lang=js&"
export * from "./StepExtendedBanners.vue?vue&type=script&lang=js&"
import style0 from "./StepExtendedBanners.vue?vue&type=style&index=0&id=97f8679a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f8679a",
  null
  
)

export default component.exports